import { Component, computed, output } from '@angular/core'
import { RouterLink } from '@angular/router'
import { Uuid } from '@ftr/contracts/type/shared'
import { AnchorComponent, EmptyStateComponent, IconButtonComponent, selectWith } from '@ftr/foundation'
import { AppPaths, RequestPaths } from '@ftr/routing-paths'
import { CartState } from '../../../store'
import { RequestCartGroupMetadataComponent } from '../cart-group-metadata'
import { CartTimesDisplayComponent } from '../cart-times-display'
import { CART_ITEM_REQUEST_TYPE } from '../request-cart.component'

@Component({
  selector: 'ftr-request-cart-side-panel',
  templateUrl: './request-cart-side-panel.component.html',
  styleUrl: './request-cart-side-panel.component.css',
  imports: [
    AnchorComponent,
    CartTimesDisplayComponent,
    EmptyStateComponent,
    IconButtonComponent,
    RequestCartGroupMetadataComponent,
    RouterLink,
  ],
})
export class RequestCartSidePanelComponent {
  readonly closePanel = output()

  protected readonly cartPath = ['/', AppPaths.Request, RequestPaths.Cart]

  protected readonly cartGroups = selectWith(() => CartState.groupedCartItems)
  private readonly courtSystem = selectWith(() => CartState.cartCourtSystem)
  protected readonly courtSystemId = computed<Uuid | undefined>(() => this.courtSystem()?.id)
  protected readonly checkoutPath = computed<string[] | undefined>(() => {
    const courtSystemId = this.courtSystemId()
    if (!courtSystemId) {
      return undefined
    }

    return [
      '/',
      AppPaths.Request,
      CART_ITEM_REQUEST_TYPE,
      RequestPaths.CourtSystem,
      courtSystemId,
      RequestPaths.Checkout,
    ]
  })

  protected readonly cartGroupIsPopulated = computed<boolean>(() => this.cartGroups().length > 0)
}
